module.exports = __webpack_public_path__ + "img/homeCbg.c174d73e.png";